<div id="main-content-container" class="component-backdrop shadow-5">
    <ng-content></ng-content>
</div>